<template>
  <div v-if="loaded" class="row">
    <!-- Réorganise ton formulaire ici -->
    <mh-input mhClass="col-6" field="type" :table="invoice"></mh-input>
    <mh-input mhClass="col-6" field="numero" :table="invoice"></mh-input>
    <mh-input mhClass="col-6" field="date" :table="invoice"></mh-input>
    <mh-input  mhClass="col-6" field="echeance" :table="invoice"></mh-input>
    <mh-input @change="update_solde" mhClass="col-6" field="montant" :table="invoice" append="€"></mh-input>
    <mh-input mhClass="col-6" field="solde" :table="invoice" append="€"></mh-input>
    <mh-input
      mhClass="col-12"
      field="reference_client"
      label="Référence client"
      :table="invoice"
    ></mh-input>
    <mh-input mhClass="col-12" field="note" :table="invoice"></mh-input>

    <b-col class="text-right mt-3">
      <b-button @click="$emit('close')">Annuler</b-button>
      <b-button @click="save" class="ml-3">Enregistrer</b-button>
    </b-col>
  </div>
</template>

<script>
import warrants from "@/services/warrants";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "WarrantInvoice",
  components: {
    MhInput,
  },
  props: {
    invoice_id: [Number, String],
    warrant_id: [Number, String],
  },
  data() {
    return {
      invoice: {},
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    update_solde() {
      console.log('change ' + this.invoice.montant.value);
      this.invoice.solde.value = this.invoice.montant.value
    },
    load() {
      warrants
        .invoice({
          warrant_id: this.warrant_id,
          invoice_id: this.invoice_id,
        })
        .then((response) => {
          this.invoice = response.data;
          this.loaded = true;
        });
    },

    save() {
      warrants
        .update_invoice({
          warrant_id: this.warrant_id,
          invoice_id: this.invoice_id,
          invoice: this.invoice,
        })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Facture mise à jour", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            for (let el in this.invoice) {
              if (this.invoice[el]) {
                this.invoice[el].error = false;
              }
            }
            this.$emit("change");
            this.$emit("close");
          } else if (response.data.fail) {
            for (let el in this.invoice) {
              if (this.invoice[el]) {
                this.invoice[el].error = false;
              }
            }
            response.data.fail.forEach((element) => {
              this.invoice[element.field].error = element.errors.join(" ; ");
            });
          } else if (response.data.error) {
            this.$bvToast.toast("Erreur : " + response.data.error, {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "danger",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>